<template>
<!-- 走班排课选课 -->
  <div class="choseCourse">
    <div class="fl" v-if="list">
      <van-sidebar v-model="activeKey" @change="getIndex">
        <van-sidebar-item
          v-for="item in list"
          :key="item.SubjectGroupID"
          :title="item.SubjectGroupName"
        ></van-sidebar-item>
      </van-sidebar>
    </div>
    <div class="content fr"  style="margin-bottom: 65px;" v-if="list">
      <div class="content-header">
        <p>{{list[index].SubjectGroupName}}</p>
        <p>
          本次最少选
          <span>{{list[index].MinSubjectNum}}</span>门，最多选
          <span>{{list[index].MaxSubjectNum}}</span>门
        </p>
      </div>
      <div class="content-main">
        <p>{{list[index].Subjects[0].SubjectGroupName}}</p>
        <p>
          本次最少选
          <span>{{list[index].MinSubjectNum}}</span>门，最多选
          <span>{{list[index].MaxSubjectNum}}</span>门
        </p>
        <div class="course" v-for="item in list[index].Subjects" :key="item.AID">
          <div>
            <span>{{item.SubjectName}}</span>
            <img :src="igmUrl" alt />
            <p>当前已选{{item.SelectCount}}人</p>
            <div class="btn" v-if="item.DetailID === 0" @click="chose(item)">选择</div>
            <div class="btn2" v-if="item.DetailID > 0" @click="chose(item)">已选</div>
          </div>
        </div>
      </div>
    </div>
    <SingleBottomBtn @clickBtn="complete">完成</SingleBottomBtn>
  </div>
</template>
<script>
const courseUrl = require("@/assets/csmsTimeTable/onlineCourseSelection/course-class-img.png");
import SingleBottomBtn from "@/components/SingleBottomBtn";
export default {
  components: {
    SingleBottomBtn
  },
  data() {
    return {
      igmUrl: courseUrl,
      activeKey: 0,
      index: 0,
      list: []
    };
  },
  created() {
    this.getSubjec();
  },
  methods: {
    getIndex(_index) {
      this.index = _index;
    },
    async getSubjec() {
      let res = await this.xyapi.get(
        this.$store.state.apiPath +
          "/api/StudentOnLineSelectCourse/GetMovingClassOnLineList",
        {
          classTableID: this.$route.params.classTableID,
          selectType: 0,
          studentID: 0
        }
      );
      if (res.success) {
        if (res.data.List.length) {
          this.list = res.data.List;
        }
      }
    },
    async chose(i) {
      if (i.DetailID === 0) {
        let res = await this.xyapi.post(
          this.$store.state.apiPath +
            "/api/StudentOnLineSelectCourse/MovingClassSelect",
          {
            ClassTableID: this.$route.params.classTableID,
            CoursePlanID: i.AID,
            CoursePlanLevelID: i.CoursePlanID,
            CourseType: i.Type,
            SelectiveCourse: i.SelectiveCourse,
            StudentID: 0,
            SubjectID: i.SubjectID
          }
        );
        if (res.success) {
          this.getSubjec();
        }
      } else if (i.DetailID > 0) {
        let res = await this.xyapi.post(
          this.$store.state.apiPath +
            "/api/StudentOnLineSelectCourse/MovingClassUnSelect",
          {
            PreselectionID: i.DetailID,
            StudentID: 0,
            UnSelectiveCourse: null
          }
        );
        if (res.success) {
          this.getSubjec();
        }
      }
    },
    async complete() {
      let res = await this.xyapi.post(
        this.$store.state.apiPath +
          "/api/StudentOnLineSelectCourse/CompleteSelectCourse",
        {
          ClassTableID: this.$route.params.classTableID,
          StudentID: 0,
          CollectionID: this.$route.params.CollectionID
        }
      );
      if (res.success) {
        this.$router.push(`/home/onlineChoseClass`);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.choseCourse {
  width: 100%;
  .van-sidebar-item--select {
    color: #323233;
    font-weight: 500;
    border-color: #4196ff;
  }
  .van-sidebar-item {
    border-bottom: 1px solid #e6e6e6;
    line-height: inherit;
  }
  .fl {
    width: 20%;
    background: rgba(249, 249, 249, 1);
    box-shadow: 0px 4px 8px 0px rgba(151, 151, 151, 0.2);
  }
  .fr {
    width: 78%;
    margin: 10px auto;
  }
  .content {
    background-color: #fff;
    .content-header {
      padding: 15px 0 20px 20px;
      height: 100px;
      width: 100%;
      background-image: url("./../../../../assets/csmsTimeTable/onlineCourseSelection/conheader.png");
      background-size: cover;
      line-height: 35px;
      p:nth-child(1) {
        font-size: 26px;
        color: rgba(51, 51, 51, 1);
      }
      p:nth-child(2) {
        font-size: 22px;
        color: rgba(153, 153, 153, 1);
      }
      p {
        span {
          color: #545efa;
          font-weight: bold;
        }
      }
    }
    .content-main {
      padding-top: 55px;
      text-align: center;
      p:nth-child(1) {
        font-size: 28px;
        color: #1d2157;
        font-weight: bold;
      }
      p:nth-child(2) {
        font-size: 22px;
        color: rgba(153, 153, 153, 1);
        line-height: 35px;
      }
      p {
        span {
          color: #545efa;
          font-weight: bold;
        }
      }
      .course {
        padding-left: 30px;
        margin-top: 20px;
        padding-top: 25px;
        border-top: 1px solid #e6e6e6;
        // border-bottom: 1px solid #e6e6e6;
        div {
          position: relative;
          height: 150px;
          span {
            float: left;
          }
          img {
            position: absolute;
            width: 58px;
            height: 64px;
            left: 0;
            top: 25%;
          }
          p {
            position: absolute;
            left: 20%;
            top: 40%;
            font-size: 22px;
            text-align: left;
            font-weight: normal;
            color: #999999;
          }
          .btn {
            position: absolute;
            right: 5%;
            top: 25%;
            width: 124px;
            height: 52px;
            border: 1px solid rgba(255, 149, 0, 1);
            box-shadow: 0px 4px 8px 0px rgba(228, 111, 86, 0.5);
            border-radius: 26px;
            line-height: 52px;
            text-align: center;
            font-weight: normal;
            font-size: 24px;
            font-weight: 400;
            color: rgba(246, 141, 5, 1);
          }
          .btn2 {
            position: absolute;
            right: 5%;
            top: 25%;
            width: 124px;
            height: 52px;
            background:rgba(255,149,0,1);
            box-shadow:0px 4px 8px 0px rgba(228,111,86,0.5);
            border-radius: 26px;
            line-height: 52px;
            text-align: center;
            font-weight: normal;
            font-size: 24px;
            font-weight: 400;
            color: #FFFFFF;
          }
        }
      }
    }
  }
}
</style>